import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CitadelErrorLoggingService, CitadelNotificationService } from '@citadel/core';

@Component({
    selector: 'app-error-page',
    templateUrl: './error-page.component.html',
    styleUrls: ['./error-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ErrorPageComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private errorLog = inject(CitadelErrorLoggingService);
  private alert = inject(CitadelNotificationService);

  ngOnInit() {
    const errorMessage = this.route?.snapshot?.queryParams?.['message'] || 'An error occurred during authentication';
    const correlationID = this.route?.snapshot?.queryParams?.['correlationID'] || crypto.randomUUID();
    this.alert.error(errorMessage);
    this.errorLog.correlationID = correlationID;
    this.errorLog.logError('auth-error', `${errorMessage}. Parameters: ${JSON.stringify(this.route.snapshot.queryParams)}`);
    this.router.navigate(['/sign-in']);
  }
}
